import Settings from '@/config/Settings'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    loaded: !Settings.loader,
    clicked: false,
    progressObj: { loader: 0 },
    progress: 0,
    promises: [],
  },
  mutations: {
    'SET_PROGRESS' (state, obj) {
      state.progressObj[obj.type] = obj.value

      state.progress = _.reduce(state.progressObj, (sum, n) => {
        return sum + n
      }, 0) / _.size(state.progressObj)
    },
    'LOADER_LOADED' (state) {
      state.loaded = true
    },
    'PROMISE_PUSH' (state, promise) {
      if(state.promises)
        state.promises.push(promise)
    },
    'PROMISE_DEACTIVATE' (state) {
      state.promises = null
    },
    'CLICKED' (state) {
      state.clicked = true
    }
  },
  getters: {
    loaded: state => state.loaded,
    clicked: state => state.clicked,
    promises: state => state.promises,
    progress: state => state.progress
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/Loader.js